import { ReactNode } from 'react';

interface UnitsSectionProps {
  title: string;
  description?: string;
  error?: string | null;
  children: ReactNode;
}

export default function UnitsSection({ title, description, error, children }: UnitsSectionProps) {
  return (
    <section style={{ marginTop: 36 }} aria-label={title}>
      <h2 className="t-h3" style={{ margin: '0 0 6px' }}>{title}</h2>
      {description && (
        <p className="t-body" style={{ margin: '0 0 14px', maxWidth: 620, fontSize: 13 }}>{description}</p>
      )}
      {error && (
        <div
          style={{
            padding: '10px 14px',
            border: '1px solid var(--danger-line)',
            background: 'var(--danger-wash)',
            color: 'var(--danger)',
            borderRadius: 'var(--r-md)',
            fontSize: 13,
            marginBottom: 12,
          }}
        >
          {error}
        </div>
      )}
      {children}
    </section>
  );
}
